import React from 'react';
import { Cookie } from 'lucide-react';
import CmsManagedInfoPage from '../components/site/CmsManagedInfoPage';

const CookiePolicyFallback: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <section className="bg-gradient-to-br from-amber-500 via-amber-600 to-orange-700 text-white py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Cookie className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Cookie Policy</h1>
            <p className="text-xl text-amber-100">How we use cookies and similar technologies</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none text-gray-600">
              <p className="text-sm text-gray-500 mb-8">Last updated: March 31, 2024</p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">What Are Cookies?</h2>
              <p>
                Cookies are small text files that are placed on your device when you visit our website. They help us
                provide you with a better experience by remembering your preferences and enabling certain features.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Types of Cookies We Use</h2>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Essential Cookies</h3>
              <p>
                These cookies are necessary for the website to function properly. They enable core functionality such as
                security, network management, and account access. You cannot opt out of these cookies.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Analytics Cookies</h3>
              <p>
                We use analytics cookies to understand how visitors interact with our website. This helps us improve our
                site and your shopping experience.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Functional Cookies</h3>
              <p>These cookies remember your preferences and settings to provide enhanced, personalized features.</p>

              <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Marketing Cookies</h3>
              <p>
                These cookies are used to deliver relevant advertisements and track the effectiveness of our marketing
                campaigns.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Managing Cookies</h2>
              <p>Most web browsers allow you to control cookies through their settings. You can:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Delete existing cookies</li>
                <li>Block all cookies</li>
                <li>Allow cookies from specific websites</li>
                <li>Set preferences for different types of cookies</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Third-Party Cookies</h2>
              <p>We may use third-party services that set their own cookies. These include:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Google Analytics (usage analytics)</li>
                <li>Facebook Pixel (advertising)</li>
                <li>Payment processors</li>
                <li>Social media platforms</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Updates to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time. Any changes will be posted on this page with an
                updated revision date.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p>If you have any questions about our use of cookies, please contact us at privacy@nlsstore.com.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
);

const CookiePolicy: React.FC = () => (
  <CmsManagedInfoPage route="/cookie-policy" fallback={<CookiePolicyFallback />} />
);

export default CookiePolicy;
